import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckBox from '../../Controls/custom/checkers/checkbox';

// import './css/filter.css';

function LocationFilter(props) {
    const dispatch = useDispatch();

    const locationFilter = useSelector(props.locationFilterSelector);

    const [open, setOpen] = useState(false);

    const locationContainerRef = useRef(null);

    let _locations = props.locations;

    let locationsList;
    let isLocationsSelected = (locationFilter.value && Array.isArray(locationFilter.value) && locationFilter.value.length > 0);
    if (_locations && Array.isArray(_locations) && _locations.length > 0) {
        locationsList = _locations.map((location, index) => (
            <li key={location.value} className="filter-list-item"
                onClick={(e) => props.onLocationChanged && props.onLocationChanged(e, location.value, _locations)}>
                <CheckBox
                    id={`ckbLocation-${location.value}`}
                    size="Small"
                    checked={isLocationsSelected ? locationFilter.value.includes(location.value) : false} />
                <span className={`ms-3 ${isLocationsSelected && locationFilter.value.includes(location.value) ? "filter-selected" : ""}`}>{location.text}</span>

            </li>
        ));

    }

    useEffect(() => {
        if (open && locationContainerRef && locationContainerRef.current) {
            locationContainerRef.current.focus();
        }
    });

    // const onLocationChanged = async (e, value) => {
    //     await dispatch(updateLocationFilter({
    //         locations: _locations,
    //         value: value
    //     }));
    // };

    const onSetSelectedFilter = (e) => {
        setOpen(true);
    };

    const onBlur = (e) => {
        setOpen(false);
    };

    return (
        <div className="filter">
            <div className={`filter-title ${open ? "filter-value-selected" : ""}`}
                onClick={(e) => onSetSelectedFilter(e)}>
                <span>Location</span> :
                <span className="filter-value">{locationFilter.value ? locationFilter.text : "All"}
                    <i className="fa fa-angle-down ms-2" aria-hidden="true"></i></span>
            </div>
            {open ? <div
                className="filter-control-container"
                ref={locationContainerRef}
                tabIndex={-1}
                onBlur={(e) => onBlur(e)}>
                <ul className="filter-list">
                    {locationsList}
                </ul>
            </div> : <React.Fragment></React.Fragment>}
        </div>
    );
}

export default LocationFilter;